import React from 'react';
import PropTypes from 'prop-types';
import { TouchableOpacity, View, ScrollView } from 'react-native';

import BlurModal from '../blur-modal';
import { Radio } from '@dbk/ui-forms';

import Text from '@dbk/ui-text';
import Flexheight from '../flex-height';
import styles from './modal-selector.styles';
import { Close } from '@dbk/ui-icons';
import Search from '@dbk/ui-search';
import SearchWithoutCircleIcon from '../../../common/components/icons/search-without-circle';
import debounce from 'lodash/debounce';
import { PORTFOLIO_RELIDTYPE } from '../../../constants';

const DEBOUNCE_TIME = 800;
function ModalSelector({
  title,
  visible,
  options,
  selectedOption,
  renderOption: customRenderOption,
  onSelect,
  onDone,
  doneLabel,
  searchText,
  handleSearchChange,
  messages
}) {
 
  const rowCount = options.length;

  return (
    <BlurModal
      title={title}
      visible={visible}
      onDone={onDone}
      doneLabel={doneLabel}
      className="model-window-portfolio-selector"
      testID="modal_portfolio_modalSelector_test"
    >
      <Flexheight ratio={0.7}>
        <div role="search">
        <Search
          value={searchText}
          size={"large"}
          iconLeft={<SearchWithoutCircleIcon style={styles.searchCircle} width={24} height={24} />}
          iconRight={Close}
          onChange={debounce((value) => handleSearchChange(value), DEBOUNCE_TIME)}
          className="search-button"
          aria-label={messages['app.dashboard.accountPortfolioSearch']}
          
        />
        </div>
        {options.map((option, index) => {
          const isLastRow = (index === rowCount - 1);
          let isTrue = checkIfSelected((option.id === (selectedOption && selectedOption.id)) && (option.relId === (selectedOption && selectedOption.relId)));
           const portfolioItemClass = option.relIdType !== PORTFOLIO_RELIDTYPE.PORTFOLIOS ? "portfolio-item" :"portfolio-item portfolio-sub-item";
          return (
            <div className={portfolioItemClass} id={"text_portfolio_modalSelector_test_" + index}>
            <View key={index}>
              <TouchableOpacity
                testID={`text_portfolio_${index}_modalSelector_test`}
                onPress={() => onSelect(option)}   // WMCE - 7687 To close modal on same selection
                style={styles.option}
              >
                <View style={[styles.wrapper]}>
                  <View style={styles.selected}>
                    <Radio tabIndex={-1} title={messages["app.accessibility.radiobtn"]} checked={(option.id === (selectedOption && selectedOption.id)) && (option.relId === (selectedOption && selectedOption.relId))} />
                  </View>
                  <div className="flex full-height">
                    {renderOption(option, index)}
                  </div>
                </View>
              </TouchableOpacity>
            </View>
            </div>
          );
        }
        )}
      </Flexheight>
    </BlurModal>
  );

  function checkIfSelected(isSelected) {
    if (isSelected) {
      return false;
    }
    return true;
  }

  function renderOption(option, index, isTrue) {
    if (!customRenderOption) {
      return (
        <Text>
          {option.title || option.id}
        </Text>
      );
    }

    return customRenderOption(option, index, isTrue);
  }
}

ModalSelector.defaultProps = {
  visible: false,
};

ModalSelector.propTypes = {
  title: BlurModal.propTypes.title,
  visible: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    relId: PropTypes.string,
    branchCode: PropTypes.number,
  })).isRequired,
  selectedOption: PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    relId: PropTypes.string,
    branchCode: PropTypes.number,
  }),
  renderOption: PropTypes.func,
  onSelect: PropTypes.func.isRequired,
  onDone: PropTypes.func,
  doneLabel: PropTypes.string,
};

export default ModalSelector;
